var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "35px",
    height: "37px",
    viewBox: "0 0 35 37",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logout") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Symbols",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "header",
    transform: "translate(-1311.000000, -28.000000)",
    fill: "#000000",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-3",
    transform: "translate(1233.000000, 28.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logout",
    transform: "translate(78.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5050452,17.5290001 L30.2251184,14.4703621 C29.4496488,13.9162404 28.3778507,14.480499 28.3778507,15.4412829 L28.3778507,17.312008 L11.8278272,17.312008 C11.1806389,17.312008 10.6558727,17.8438761 10.6558727,18.5 C10.6558727,19.1561239 11.1806389,19.6879128 11.8278272,19.6879128 L28.3776944,19.6879128 L28.3776944,21.5585588 C28.3776944,22.5256782 29.4551957,23.0794039 30.2248841,22.5294795 L34.5048108,19.4708416 C35.1584053,19.004071 35.1716085,18.0063826 34.5050452,17.5290001 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6305854,26.1277466 C33.0705066,25.7994075 32.3534745,25.9932749 32.0293335,26.5612556 C29.2765179,31.3854488 24.1306526,34.6240952 18.2502553,34.6240952 C9.47946397,34.6240952 2.34383081,27.3908148 2.34383081,18.5 C2.34383081,9.60918524 9.47946397,2.37590485 18.2502553,2.37590485 C24.1345589,2.37590485 29.2780804,5.61756056 32.0292554,10.438586 C32.3533183,11.0065667 33.0705066,11.2003549 33.6305072,10.872095 C34.1907422,10.5435975 34.3821487,9.8168324 34.058164,9.24893088 C30.8920666,3.70074443 24.9788567,0 18.2502553,0 C8.16329059,0 0,8.27412961 0,18.5 C0,28.7249993 8.16243122,37 18.2502553,37 C24.9817473,37 30.8934729,33.2966422 34.0582421,27.7509107 C34.3822268,27.1830092 34.1908204,26.4563233 33.6305854,26.1277466 Z",
    id: "Path"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.7d3f9bef81cb81b3698808b4292fd30f.svg";
export { ForwardRef as ReactComponent };